import { render, staticRenderFns } from "./errorTipModal.vue?vue&type=template&id=2b85df75&scoped=true"
import script from "./errorTipModal.vue?vue&type=script&lang=js"
export * from "./errorTipModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b85df75",
  null
  
)

export default component.exports